module.exports = __webpack_public_path__ + "static/img/best-ensemble-3b-frances-hawkes-hedges.90f92d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best-ensemble-3b-frances-hawkes-hedges.jpg
// module id = 169
// module chunks = 0